<div class="component d-flex flex-row">
    <mat-selection-list #itemList [multiple]="false" (selectionChange)="onSelectItem()">
        <mat-list-option *ngFor="let exerciseType of availableTypes" [value]="exerciseType">
            {{getExerciseTitle(exerciseType)}}
        </mat-list-option>
    </mat-selection-list>
</div>
